/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/* eslint-disable no-param-reassign */
import { types } from 'mobx-state-tree';

export default types.model('LessonPublishingStatus', {
  componentName: types.maybeNull(types.string),
  projectDurn: types.string,
  projectEntityUrn: types.string,
  mouduleUrn: types.string,
  slateUrn: types.string,
  assessmentUrn: types.string,
  lessonName: types.string,
  transactionId: types.string,
  status: types.string,
  publishedBy: types.string,
  publishingStartTime: types.string,
  publishingEndTime: types.maybeNull(types.string),
  additionalDetails: types.maybeNull(types.string)
});
